import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { ProduccionPage } from './pages/ProduccionPage';
import { ProduccionDelDiaPage } from './pages/ProduccionDelDiaPage';
import { MovimientosPage } from './pages/MovimientosPage';
import { VentasPage } from './pages/VentasPage';
import { ComprasPage } from './pages/ComprasPage';
import { InventarioPage } from './pages/InventarioPage';
import { InsumosPage } from './pages/InsumosPage';
import { InversionesPage } from './pages/InversionesPage';
import { ReportesPage } from './pages/ReportesPage';
import { PuntoEquilibrioPage } from './pages/PuntoEquilibrioPage';
import { AdminPage } from './pages/AdminPage';
import { ConfiguracionPage } from './pages/ConfiguracionPage';
import { BitacoraPage } from './pages/BitacoraPage';
import { BitacoraDetallePage } from './pages/BitacoraDetallePage';

export function App() {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-slate-500 text-sm">Cargando…</div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/produccion" element={<ProduccionPage />} />
        <Route path="/produccion-del-dia" element={<ProduccionDelDiaPage />} />
        <Route path="/bitacora" element={<BitacoraPage />} />
        <Route path="/bitacora/:id" element={<BitacoraDetallePage />} />
        <Route path="/movimientos" element={<MovimientosPage />} />
        <Route path="/ventas" element={<VentasPage />} />
        <Route path="/compras" element={<ComprasPage />} />
        <Route path="/inventario" element={<InventarioPage />} />
        <Route path="/insumos" element={<InsumosPage />} />
        <Route path="/inversiones" element={<InversionesPage />} />
        <Route path="/reportes" element={<ReportesPage />} />
        <Route path="/punto-equilibrio" element={<PuntoEquilibrioPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/configuracion" element={<ConfiguracionPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
